import { AxiosInstance } from 'axios';
import {
  AccountTransferAlertRepository,
  AccountTransferAlertResponse,
} from '@/model/repository/manager/accountTransfer/AccountTransferAlertRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AccountTransferAlertRepository => ({
    get(): AccountTransferAlertResponse {
      return Repository.get(`${resource}`);
    },
  });
